import React from 'react';

import { Button } from 'components/Button';
import CustomModal from 'components/CustomModal';

import { PAGES_LIMITATIONS } from './constants';
import { LimitationsList, ModalNote } from './styles';

interface ViewModeFlipModalProps {
  open: boolean;
  // The mode being switched to. Switching to pages surfaces the known
  // pagination limitations; switching to pageless is a plain reload confirm.
  toPages: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const RELOAD_NOTE = 'Changing the view reloads the document for everyone currently viewing it.';

const ViewModeFlipModal: React.FC<ViewModeFlipModalProps> = ({ open, toPages, onConfirm, onCancel }) => (
  <CustomModal
    openModal={open}
    onClose={onCancel}
    modalTitle={toPages ? 'Switch to pages view' : 'Switch view mode'}
    modalDescription={
      toPages ? 'Pages view has a few limitations to be aware of:' : `${RELOAD_NOTE} Do you want to continue?`
    }
    cancelButton={
      <Button variant="outlined" size="medium" onClick={onCancel}>
        Cancel
      </Button>
    }
    submitButton={
      <Button variant="contained" color="primary" size="medium" onClick={onConfirm}>
        {toPages ? 'Switch to pages' : 'Switch view mode'}
      </Button>
    }
  >
    {toPages && (
      <>
        <LimitationsList>
          {PAGES_LIMITATIONS.map((limitation) => (
            <li key={limitation}>{limitation}</li>
          ))}
        </LimitationsList>
        <ModalNote>{RELOAD_NOTE} Do you want to continue?</ModalNote>
      </>
    )}
  </CustomModal>
);

export default ViewModeFlipModal;
